export default "__VITE_ASSET__kwKeHM9P__"